import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteHowItWork, getHowItWorks } from "../../redux/services/howItWorkSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";

const HowItWork = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getHowItWorkData = useSelector((state) => state?.howItWork?.howItWorkData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllHowItWorks = useCallback(async () => {
    try {
      await dispatch(
        getHowItWorks({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllHowItWorks();
  }, [getAllHowItWorks]);

  const deleteHowItWorkData = async () => {
    try {
      const response = await dispatch(deleteHowItWork(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllHowItWorks();
    } catch (error) {}
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Title", key: "title" },
    { header: "Description", key: "description" },
    {
      header: "Thumbnail",
      key: "thumbnailImage",
      render: (thumbnailImage) => (
        <img
          src={thumbnailImage}
          alt="thumbnail"
          className="w-20 h-14 object-cover rounded-xl"
        />
      ),
    },
    {
      header: "Link",
      key: "link",
      render: (link) => (
        <a href={link} target="_blank" rel="noreferrer" className="text-primary underline">
          Visit
        </a>
      ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WEBSITE.HOW_IT_WORKS_ADD_EDIT}?howItWorkId=${row._id}`, { state: { row } });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table
        title="How It Works"
        buttonTitle="Add How It Work"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate(ROUTES.WEBSITE.HOW_IT_WORKS_ADD_EDIT)}
        columns={columns}
        data={getHowItWorkData?.how_it_work_data || []}
        actions={actions}
        pageCount={getHowItWorkData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="How It Work"
          confirm={confirm}
          onDelete={deleteHowItWorkData}
          onCancel={() => setConfirm(false)}
        />
      )}
    </>
  );
};

export default HowItWork;
